import React, { useState, useRef, useEffect } from "react";
import "../../css/designSystem/Navbar.css";
import {ReactComponent as NavLogo} from "../../assets/icons/navbar_logo.svg";
import SecondaryButton from "./buttons/SecondaryButton";
import { useLocation, useNavigate } from "react-router-dom";
import LightOutlinedButton from "./buttons/LightOutlinedButton";
import { openClientPortal, scrollToContact } from "../utils/navigation";

const serviceLinks = [
  { label: "Pensions", path: "/pensions" },
  { label: "Investments", path: "/investments" },
  { label: "Mortgages", path: "/mortgages" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const servicesRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setShowServicesDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!location.hash) return;

    const sectionId = location.hash.slice(1);
    window.setTimeout(() => {
      document
        .getElementById(sectionId)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }, [location.pathname, location.hash]);

  const handleNavigate = (path) => {
    setShowServicesDropdown(false);
    setIsMobileMenuOpen(false);
    navigate(path);
  };

  const handleContactClick = () => {
    setShowServicesDropdown(false);
    setIsMobileMenuOpen(false);
    scrollToContact();
  };

  const navTextClass = (path, exact = true) => {
    const isActive = exact
      ? location.pathname === path
      : location.pathname.startsWith(path);

    return `nav-text ${isActive ? "is-active" : ""} text-hover-primary-2`;
  };

  const isServicesPage = serviceLinks.some(
    ({ path }) => location.pathname === path,
  );

  return (
    <nav className="navbar ">
      <div className="navbar-main-row">
        <div className="navbar-left">
          <NavLogo
            alt="Monk Financial Planning Logo"
            className="navbar-logo"
            onClick={() => {
              handleNavigate("/");
            }}
          />
        </div>

        <button
          type="button"
          className={`navbar-toggle ${isMobileMenuOpen ? "is-open" : ""}`}
          aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMobileMenuOpen}
          onClick={() => {
            setIsMobileMenuOpen((prev) => !prev);
            setShowServicesDropdown(false);
          }}
        >
          <span className="navbar-toggle-line line-1" />
          <span className="navbar-toggle-line line-2" />
          <span className="navbar-toggle-line line-3" />
        </button>
      </div>

      <div className={`navbar-content ${isMobileMenuOpen ? "is-open" : ""}`}>
        <ul className="navbar-links">
          <li>
            <span
              className={navTextClass("/about-us")}
              onClick={() => handleNavigate("/about-us")}
            >
              About Us
            </span>
          </li>

          <li ref={servicesRef} style={{ position: "relative" }}>
            <button
              type="button"
              className={`navbar-dropdown-trigger nav-text ${
                isServicesPage ? "is-active" : ""
              } text-hover-primary-2`}
              aria-expanded={showServicesDropdown}
              aria-controls="services-dropdown"
              onClick={() => setShowServicesDropdown((isOpen) => !isOpen)}
            >
              Our Services
            </button>
            {showServicesDropdown && (
              <ul id="services-dropdown" className="navbar-dropdown">
                {serviceLinks.map(({ label, path }) => (
                  <li key={path}>
                    <SecondaryButton
                      onClick={() => handleNavigate(path)}
                      text={label}
                    />
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li>
            <span
              className={navTextClass("/financial-advice")}
              onClick={() => handleNavigate("/financial-advice")}
            >
              Financial Advice
            </span>
          </li>
          <li className="navbar-responsive-only">
            <span
              className="nav-text text-hover-primary-2"
              onClick={handleContactClick}
            >
              Contact Us
            </span>
          </li>
          {/* <li className="navbar-responsive-only">
            <span
              className="nav-text text-hover-primary-2"
              onClick={openClientPortal}
            >
              Client Portal
            </span>
          </li> */}
        </ul>

        <div className="navbar-actions gap-m row-center">
          <SecondaryButton onClick={handleContactClick} text="Contact Us" />
          {/* <LightOutlinedButton
            onClick={openClientPortal}
            text="Client Portal"
          /> */}
        </div>

        {/* <div className="navbar-mobile-menu">
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/services/mortgages");
            }}
          >
            Find A Mortgage
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/services/protection");
            }}
          >
            Insurance & Protection
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/about-us");
            }}
          >
            Honest Pricing
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/calculators/mortgage-borrow");
            }}
          >
            Useful Tools
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/about-us");
            }}
          >
            About Us
          </button>
          <button
            type="button"
            className="navbar-mobile-link"
            onClick={() => {
              handleNavigate("/blogs");
            }}
          >
            Blogs
          </button>

          <button
            type="button"
            className="navbar-mobile-cta"
            onClick={() => {
              handleNavigate("/contact-us");
            }}
          >
            Contact Us
          </button>
        </div> */}
      </div>
    </nav>
  );
};

export default Navbar;
